<template>
<div>
  <form @submit.prevent="tryToReset">
    <b-alert
        v-model="isResetError"
        class="mb-4"
        variant="danger"
        dismissible
    >{{ error }}</b-alert
    >
    <div class="my-4">
      <label for="code">Old Password</label>
      <input
          type="password"
          v-model="old_password"
          class="form-control py-2"
          id="code"
          placeholder="Enter Old Password"
          :class="{ 'is-invalid': submitted && v$.old_password.$error }"
      />
      <p
          v-for="error of v$.old_password.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>

    <div class="my-4">
      <label for="password">New Password</label>
      <input
          type="password"
          v-model="password"
          class="form-control py-2"
          id="password"
          placeholder="Enter New Password"
          :class="{ 'is-invalid': submitted && v$.password.$error }"
      />
      <p
          v-for="error of v$.password.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>

    <div class="my-4">
      <label for="confirm-password">Confirm New Password</label>
      <input
          type="password"
          v-model="confirmPassword"
          class="form-control py-2"
          id="confirm-password"
          placeholder="Confirm New Password"
          :class="{ 'is-invalid': submitted && v$.confirmPassword.$error }"
      />
      <div v-if="v$.confirmPassword.$error" class="invalid-feedback">
        <span v-if="v$.confirmPassword.required.$invalid">Confirm Password is required</span>
        <span v-else-if="v$.confirmPassword.sameAs.$invalid">Passwords must match</span>
      </div>
    </div>

    <div v-for="(error, index) in authErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>

    <div class="mt-3 d-grid">
      <b-button variant="primary" size="lg" v-if="authLoading" disabled>
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button v-else variant="primary" size="sm" class="py-2 h4 text-white" type="submit"
      >Change Password</b-button
      >
    </div>
  </form>
</div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, minLength, sameAs } from '@vuelidate/validators';
import {mapActions, mapGetters} from "vuex";
export default {
name: "password-change-component",
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      old_password: "",
      password: "",
      confirmPassword: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  computed: {
    ... mapGetters({
      authLoading: 'authentication/authLoading',
      authErrors: 'authentication/authErrors'
    })
  },
  methods: {
    ... mapActions({
      changePassword: 'authentication/changePassword'
    }),
    async tryToReset() {
      this.submitted = true;

      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      await this.changePassword({newPassword:this.password, confirmPassword: this.confirmPassword, oldPassword: this.old_password})

      this.v$.$touch();
    },
  },
  validations () {
    return {
      old_password: {
        required,
      },
      password: {
        required, minLength: minLength(8)
      },
      confirmPassword: {
        required, sameAs: sameAs(this.password)
      }
    }
  },
}
</script>

<style scoped>

</style>
